import { darken, makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  grid: {
    
  },
  tabPanel: {
    display: 'flex',
    columnGap: '15px'
  },
  label: {
    color: '#000000',
    marginBottom: '5px',
  },
  button: {
    background: '#0550a0',
    color: '#fff',
    width: 200,
    height: 40,
    transition: 'filter 0.2s, color 0.2s, background-color 0.2s',
    border: '1px solid #0550a0',
    '&:hover': {
      background: '#fff',
      color: '#0550a0',
    },
    '&:disabled': {
      opacity: 0.5,
      color: '#fff'
    }
  },
  clearFiltersButton: {
    border: 'none',
    backgroundColor: 'transparent',
    padding: '10px 20px',
    fontSize: '0.9rem',
    color: '#0d47a1',
    letterSpacing: '0.03em',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    '&:hover': {
      color: darken('#0d47a1', 0.2),
    },
    '&:disabled': {
      backgroundColor: '#DDD',
    },
  },
  consultButton: {
    color: '#ffffff',
    backgroundColor: '#0d47a1',
    '&:hover': {
      backgroundColor: darken('#0d47a1', 0.2),
    },
    '&:disabled': {
      backgroundColor: '#DDD',
    },
    padding: '10px 20px',
    textTransform: 'capitalize',
    fontSize: '0.9rem',
    letterSpacing: '0.04em',
  },
  divider: {
    marginTop: '10px'
  },
  balance: {
    fontSize: '1.4rem',
    fontWeight: 300,
    marginLeft: '5px',
    lineHeight: 1,
    '& > strong': {
      fontWeight: 500
    }
  },
  addBalance: {
    marginTop: '15px'
  }
}));
